/* Demo stub — brak połączenia z API */
import { createNamedStub, createServiceStub } from "../demo/stubHelpers";

export const getUserFromToken = createNamedStub();

export default createServiceStub();
